import { request } from "../../api/api";

export const getOverviewAnalyticsPieChartData = (data) => {
    return request.post('/dashboard/getOverviewAnalyticsPieChartData/', data)
}

export const getAlarmACKCount = (data) => {
    return request.post('/dashboard/getAlarmACKCount/', data)
}

export const getOptimizedPiechartData = (params) =>{
    return request.post(`/dashboard/getOptimizedOverviewAnalyticsPieChartData/`,params)
}

export const getDeviceTagByTypeNew = (params) =>{
    return request.post(`/dashboard/getDeviceTagByTypeNew/`,params)
}
export const getMasterUIDTopic = () =>{
    return request.get(`/master_uid_topic/getMasterUIDTopic/`)
}